enum Language {
  Turkish = 'tr',
  English = 'en',
}

export default Language;
